const translations = {
  en: {
    translation: {
      clientReservationsActives: "Active Client Reservations",
      clientReservationsInactives: "Inactive Client Reservations",
      clientReservationsTimeline: "Client Reservations Calendar",
      amenityEventsWithActiveClientReservation: "Spaces Events With Active Client Reservation",
      amenityEventsAllExisting: "All Existing Spaces Events",
      serviceEventsWithActiveClientReservation: "Service Events With Active Client Reservation",
      serviceEventsAllExisting: "All Existing Service Events",
      supportCasesWithActiveClientReservation: "Support Cases With Active Client Reservation",
      supportCasesAllExisting: "All Existing Support Cases",
      chatWithActiveClientReservation: "Chats With Active Client Reservation",
      chatAllExisting: "All Existing Chats",
      todayLabel: "Today",
      oneWeek: "1 week",
      thisWeek: "Current week",
      oneMonth: "1 month",
      noEvents: "No events",
      more: "more",
      noMoreElements: "no more elements",
      selectProject: "Select project",
      select_project_and_apartment: "Select project and apartment",
      selectYourReservation: "Select your reservation",
      managerMode: "Manager Mode",
      accessAsAdministrator: "Access as administrator",
      apartment_already_reserved_in_range: "Apartment already reserved in range",
      active: "Active",
      availability: "Availability",
      available: "Available",
      activeReservation: "Active Reservation",
      total: "Total",
      totalCost: "Total cost",
      invalid_dates: "Invalid dates",
      userValidationPending: "User Validation Pending",
      userValidationPendingSubtitle: "We are validating your user, please be patient",
      account: "Account",
      sections: "Sections",
      menuSections: "Project Menu Sections",
      projectManagerSharedSectionsDescription:
        "These options grant access to shared sections in the Main Menu, Dashboard and Project Menu.",
      projectManagerExclusiveMenuSectionsDescription: "Sections exclusive to the Project Menu.",
      projectManagerMenuAccess: "Access to Project Menu",
      settings: "Settings",
      cloudApis: "Cloud APIs",
      chat: "Chat",
      typeMessage: "Type a message...",
      Logout: "Logout",
      userGrantTimeout: "User access grant timedout",
      userHasNoGrant: "User has no access grant",
      Company: "Company",
      "Basic Info": "Basic Info",
      "Custom App": "Customization",
      "Custom Welcome Mobile": "Custom Welcome App Mobile",
      "Custom Colors in App": "Custom Colors in App Mobile",
      "Custom Font in App": "Custom Font in App Mobile",
      customFont: "Custom Font",
      customCardColor: "Custom card color",
      customEmailToClients: "Custom email to clients",
      customApp: "Customization App Mobile",
      "Custom Project Menu": "Project Menu",
      "First Name": "First Name",
      "Last Name": "Last Name",
      "Phone Number": "Phone Number",
      "Project Managers": "Project Managers",
      Language: "Language",
      Address: "Address",
      City: "City",
      Postcode: "Postcode",
      "VAT Number": "VAT Number",
      // Password
      Success: "Success!",
      Password: "Password",
      PasswordRepeat: "Password Repeat",
      "Wrong Password": "Wrong Password",
      "Unknown Error": "Unknown Error",
      "Different Passwords": "Different Passwords",
      "One special character": "One special character",
      "One capital letter": "One capital letter",
      "Min 8 characters": "Minimum 8 characters",
      "One number": "One number",
      "Change Password": "Change Password",
      "Current Password": "Current Password",
      "New Password": "New Password",
      "Confirm New Password": "Confirm New Password",
      "Update Password": "Update Password",
      "Please follow this guide for a strong password":
        "Please follow this guide for a strong password",
      "Password requirements": "Password requirements",
      Notifications: "Notifications",
      notificationsToClients: "Notifications to clients",
      Type: "Type",
      Communication: "Communication",
      "Notify communication errors with Onna BTR devices":
        "Notify communication errors with Onna BTR devices",
      Alerts: "Alerts",
      "Notify technical alerts comming from sensors":
        "Notify technical alerts comming from sensors",
      projectNotificationsDevicesDescription:
        "Notify alerts about communication and status changes from project devices",
      projectNotificationsMetricsLimitDescription:
        "Notify when configured metric limits are exceeded in this project",
      "Ask Onna Team for account deletion": "Ask Onna Team for account deletion",
      "Delete Account": "Delete Account",
      image: "Image",
      wrongSize: "Wrong size, must be 256x256",
      Profile: "Profile",
      uploadFile: "Upload File",
      customWelcomeBackgroundColor: "Custom welcome background color",
      customIconColor: "Custom icon color",
      customAppBackgroundColor: "Custom app background color",
      welcomeBackgroundColor: "Welcome background color",
      configurationSent: "Configuration sent",
      Save: "Save",
      Delete: "Delete",
      Required: "Required",
      clients: "Clients",
      clientReservationsAll: "All Client Reservations",
      clientReservations: "Client Reservations",
      clientReservation: "Client Reservation",
      client: "Client",
      createClient: "Create Client",
      clientCreatedSuccessfully: "Client created successfully",
      clientUpdatedSuccessfully: "Client updated successfully",
      errorCreatingClient: "Error creating client",
      errorUpdatingClient: "Error updating client",
      clientRemovedSuccessfully: "Client removed successfully",
      errorRemovingClient: "Error removing client",
      clientReservationCreatedSuccessfully: "Client reservation created successfully",
      errorCreatingClientReservation: "Error creating client reservation",
      clientReservationUpdatedSuccessfully: "Client reservation updated successfully",
      errorUpdatingClientReservation: "Error updating client reservation",
      clientReservationRemovedSuccessfully: "Client reservation removed successfully",
      errorRemovingClientReservation: "Error removing client reservation",
      emailAlreadyExists: "Email Already Exists",
      newEmail: "New Email",
      newEmailConfirmation: "Confirm New Email",
      errorCreateCode: "Error creating lock code",
      users: "Users",
      user: "User",
      "These are the users": "These are the users shared by all your projects",
      stepNotUndo: "This action cannot be undone",
      stepNotUndoClient:
        "This action cannot be undone. The client will be deleted along with all their data, reservations and events.",
      stepNotUndoClientReservation:
        "This action cannot be undone. The client reservation will be deleted along with all their data and events.",
      projectManagerAddMainUserError:
        "This user cannot be added as project manager because the account is already a main user",
      confirmation: "Are you sure?",
      showing: "Showing",
      of: "of",
      entries: "entries",
      project: "Project",
      removeNotEmpty: "Project is not empty, cannot remove",
      createdAt: "Created At",
      lastCreatedAt: "Last Notification At",
      unreadNumber: "Unread Count",
      unreadByClientNumber: "Unread by Client",
      totalNumber: "Total Count",
      to: "to",
      add: "Add",
      edit: "Edit",
      projects: "Projects",
      allProjects: "All Projects",
      "These are the projects": "These are your projects",
      name: "Name",
      certifications: "Certifications",
      onnaDevices: "Onna Devices",
      onnaDevicesDetails: "Onna Devices Details",
      onnaDevice: "Onna Device",
      amenity: "Space",
      amenities: "Spaces",
      amenityEvents: "Spaces Events",
      reservationsToday: "Spaces Today",
      reservationsNext: "Next Spaces",
      amenityDuration: "Reservation Time",
      event: "Event",
      events: "Events",
      resourcesLimited: "Resources Limited",
      resourcesLimitNumber: "Resources Limit",
      cost: "Cost",
      costPositive: "Cost must be a positive number",
      requiredPositiveInteger: "Required positive integer",
      mustBeANumber: "Must be a numbero",
      mustBeMinOne: "Min 1",
      startMustBeEarlier: "Start time must be earlier",
      endMustBeLater: "End time must be later",
      availableDays: "Available days",
      minPreviousTime: "Minimum time in advance",
      minCancelTime: "Minimum time to cancel",
      autoConfirmateEnable: "Auto confirm spaces",
      onlyStartInEvents: "Only allow start from calendar events",
      associatedServicesEnable: "Enable services",
      associatedServices: "Associated services",
      isAssociated: "Associated",
      associatedReservationEnable: "Associated Spaces",
      onlyAssociated: "Associated only",
      servicesCategories: "Service Categories",
      selectApartmentFirst: "Please select an apartment first",
      selectClientReservationFirst: "Please select a client with an active reservation",
      projectManager: "Project Manager",
      projectManagerUnauthorizedEventEdit:
        "You are not authorized to modify this event because it does not belong to one of your authorized projects",
      invalid_service_quantity: "Invalid service quantity",
      serviceLimitReached: "Service limit reached",
      eventService: "Service Event",
      eventAmenity: "Amenity Event",
      eventUpdated: "Event updated",
      eventAdded: "Event added",
      eventRemoved: "Event removed",
      eventRemoveFailed: "Error removing the event",
      eventUpdateFailed: "Error updating the event",
      eventAddFailed: "Error adding the event",
      serviceAddedOrUpdated: "Service added or updated",
      createdServiceEvents: "Created service events",
      noServiceEventsYet: "No service events yet",
      serviceNumber: "Service number request",
      amenityNumber: "Spaces number request",
      clientLimit: "Client Limit",
      iconName: "Icon Name",
      update: "Update",
      pending: "Pending",
      processing: "Processing",
      confirmed: "Confirmed",
      canceled: "Canceled",
      completed: "Completed",
      currency: "Currency",
      no: "No",
      yes: "Yes",
      additionalInfo: "Additional Info",
      unitCost: "Unit cost",
      requestNumber: "Request number",
      inactive: "Inactive",
      none: "None",
      multiple: "multiple",
      goToServiceEvent: "Go to service event",
      serviceEventNotFound: "Service event not found",
      service: "Service",
      serviceEvents: "Service Events",
      services: "Services",
      resource: "Resource",
      resources: "Resources",
      serviceDuration: "Service Time",
      weekDayMonday: "Monday",
      weekDayTuesday: "Tuesday",
      weekDayWednesday: "Wednesday",
      weekDayThursday: "Thursday",
      weekDayFriday: "Friday",
      weekDaySaturday: "Saturday",
      weekDaySunday: "Sunday",
      serviceEventsToday: "Service Events Today",
      serviceEventsUpcoming: "Upcoming Service Events",
      unknown: "Unknown",
      accessControls: "Access Controls",
      accessControl: "Access Control",
      titleAccesses: "Access Control",
      code: "Code",
      lockCommunicationError: "Lock is offline",
      roomsLocksList: "Rooms Locks List",
      commonLocksList: "Common Locks List",
      import: "Import",
      system: "System",
      configured: "Configured",
      true: "True",
      false: "False",
      isOverlapping: "Overlaps existing event",
      startTime: "Start Time",
      endTime: "End Time",
      previousDays: "Previuos Days",
      state: "State",
      apartment: "Apartment",
      apartments: "Apartments",
      onnaId: "Onna ID",
      apartmentId: "Apartament ID",
      configuration: "Configuration",
      customizeDashboard: "Customize Dashboard",
      navbar: "Navbar",
      customizeNavbar: "Customize Navbar",
      dark: "Dark",
      transparent: "rgba(0, 0, 0, 0)",
      white: "White",
      navbarMini: "NavbarMini",
      darkMode: "Dark Mode",
      notifications: "Notifications",
      enabled: "Enabled",
      notificationsDetails: "Notifications by Apartment Details",
      message: "Message",
      read: "Read",
      readByClient: "Read by client",
      notRead: "Not Read",
      last24h: "Last 24h",
      apartmentsWithUnread: "Apartments With Unread",
      apartmentsWithoutUnread: "Apartments Without Unread",
      unreadNotifications: "Unread Notifications",
      notificationsLast24h: "Notifications Last 24h",
      correct: "Corrects",
      errored: "With Errors",
      offline: "Offline",
      online: "Online",
      lights: "Lights",
      titleLights: "Lights",
      shutters: "Motors",
      titleShutters: "Motors",
      alarms: "Alarms",
      titleAlarms: "Alarms",
      temperature: "Temperature",
      titleThermostat: "Temperature",
      thermostats: "Thermostats",
      supplies: "Supplies",
      titleSupplies: "Supplies",
      others: "Others",
      titleOthers: "Others",
      invoice: "Invoice",
      generate: "Generate",
      startDate: "Start Date",
      endDate: "End Date",
      oldClientMessage:
        "This client has been created with an old version of software. From now on, you must use reservation interface to change its availability. Press save to update it.",
      randomEntryCode: "Create and send random entry code",
      entryCode: "Entry code",
      hotWater: "Hot Water",
      coldWater: "Cold Water",
      electricity: "Electricity",
      gas: "Gas",
      limits: "Metric Limits",
      dailyLimit: "Daily Limit",
      monthlyLimit: "Monthly Limit",
      dashboard: "Dashboard",
      support: "Support",
      connected: "Connected",
      disconnected: "Disconnected",
      withError: "With Error",
      supportOpen: "Open",
      supportInProgress: "In progress",
      supportCompleted: "Completed",
      supportCasesCreatedSuccessfully: "Support case created successfully",
      supportCasesUpdatedSuccessfully: "Support case updated successfully",
      supportCasesRemovedSuccessfully: "Support case removed successfully",
      errorCreatingSupportCases: "Error creating support case",
      errorUpdatingSupportCases: "Error updating support case",
      errorRemovingSupportCases: "Error removing support case",
      lastUpdate: "Last Update",
      consumptions: "Consumptions",
      device: "Device",
      devices: "Devices",
      moment: "Moment",
      moments: "Moments",
      power: "Power",
      energy: "Energy",
      month: "Month",
      year: "Year",
      day: "Day",
      time: "Time",
      hour: "Hour",
      hourlyPeriod: "Hourly",
      dailyPeriod: "Daily",
      monthlyPeriod: "Monthly",
      annualPeriod: "Annual",
      detailPeriod: "Detail",
      minutes: "Minutes",
      byDates: "By Dates",
      standart: "Standard",
      allApartments: "All Apartments",
      customSearch: "Custom Search",
      lastHour: "Last Hour Value",
      metric: "Metric",
      show: "Show",
      showInApp: "Show in App",
      unit: "Unit",
      units: "Units",
      metricConfig: "Metrics Configuration",
      customMetrics: "Custom Metrics",
      binaryValue: "Binary Value (1/0)",
      influxErrorRequest: "The response could not be processed.",
      Δincrease: "Δ Increase",
      period: "Period",
      select: "Select",
      presence: "Presence",
      timeInPresence: "Time in presence (minutes)",
      electricEnergy: "Electric Energy",
      electricPower: "Electric Power",
      setpointTemp: "Setpoint",
      thermalEnergyCooling: "Thermal Energy Cooling",
      thermalEnergyHeating: "Thermal Energy Heating",
      custom1Linear: "Custom 1 Linear",
      custom1Incremental: "Custom 1 Incremental",
      custom2Linear: "Custom 2 Linear",
      custom2Incremental: "Custom 2 Incremental",
      customName: "Custom Name",
      makeQuery: "Make Query",
      min: "Min",
      max: "Max",
      average: "Average",
      dataType: "Data Type",
      analytics: "Analytics",
      JAN: "JAN",
      FEB: "FEB",
      MAR: "MAR",
      APR: "APR",
      MAY: "MAY",
      JUN: "JUN",
      JUL: "JUL",
      AUG: "AUG",
      SEP: "SEP",
      OCT: "OCT",
      NOV: "NOV",
      DEC: "DEC",
      ΔT: "Δ Temp. Differential",
      reload: "Reload",
      updated: "Updated",
      noPossibleShowData: "No data available.",
      noMetricsConfiguredToShow: "No metrics configured to display.",
      lastData: "Last Data Update",
      lastValue: "Last Value",
      lastDay: "Last Day Value",
      lastMonth: "Last Month Value",
      signIn: "Sign In",
      signUp: "Sign Up",
      email: "Email",
      emailConfig: "Email Configuration",
      enterEmailAndPassword: "Enter email and password",
      password: "Password",
      dontHaveAccount: "Don't have an account yet?",
      forgotPassword: "Forgot password?",
      resetPassword: "Reset Password",
      emailSent: "Email Sent!",
      emailResetSent: "Email to reset password sent!",
      invalidPassword: "Invalid password",
      invalidEmail: "Invalid email",
      userNotFound: "User not found",
      iAgreeThe: "I agree the",
      joinUsToday: "Join us today",
      today: " Today",
      yesterday: "Yesterday",
      termsAndConditions: "Terms and conditions",
      weakPassword: "Weak password",
      weakPassword1:
        "Password must contain at least 8 characters, one uppercase letter, one lowercase letter and one number",
      emailInUse: "Email in use",
      wrongPasswordForExistingEmail:
        "We could not verify your credentials. If the account exists, use password reset",
      mustUseExistingPassword:
        'Please use the existing password for this email or go back and click "Reset Password" if you don\'t remember it.',
      cannotRegisterMainUserAlreadyProjectManager:
        "This account cannot be registered as main user because it already belongs to a project manager.",
      alreadyHaveAccount: "You already have an account?",
      addOnnaDevice: "Add Onna device",
      notOpen: "Device connection is not opened. Pud device in link mode",
      alreadyAssigned: "You have no grant to add the device to your account",
      unknownDevice: "Onna ID is unknown",
      unknownError: "Unknown error",
      "IP Address": "IP Address",
      "IP Address Type": "IP Address Type",
      "Hardware Version": "Hardware Version",
      "App Version": "Software Version",
      "Onna Model": "Onna Model",
      Timezone: "Time Zone",
      Update: "Update",
      download: "Download",
      btnOn: "Turn on",
      btnOff: "Turn off",
      labelOn: "On",
      labelOff: "Off",
      btnUp: "Up",
      btnDown: "Down",
      btnOpen: "Open",
      btnClose: "Close",
      noProjectsAvailable: "No projects available",
      noResourcesAvailable: "No resources available for this project",
      schedule: "Schedule",
      scheduled: "Scheduled",
      value: "Value",
      date: "Date",
      timestamp: "Timestamp",
      days: "Days",
      schedules: "Schedules",
      weekDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      uncalibrated: "Uncalibrated",
      locked: "Locked",
      unlocking: "Unlocking",
      unlocked: "Unlocked",
      locking: "Locking",
      unlatched: "Unlached",
      unlatching: "Unlaching",
      motorBlocked: "Motor Blocked",
      undefined: "Undefined",
      loading: "Loading",
      unlock: "Unlock",
      lock: "Lock",
      occupancy: "Occupancy",
      occupied: "Occupied",
      unoccupied: "Unnocupied",
      codeAlreadyExists: "Code already exists",
      setpoint: "Desired",
      mode: "Mode",
      fan: "Fan",
      dry: "Dry",
      cool: "Cool",
      heat: "Heat",
      auto: "Auto",

      veryLow: "Very low",
      low: "Low",
      mediumLow: "Medium-low",
      medium: "Medium",
      mediumHigh: "Medium-high",
      high: "High",
      veryHigh: "Very high",
      intensity: "Intensity",
      whiteL: "White",

      angleConf: "Air Orientation",
      master: "Master",
      zone: "Zone",
      zoneMaster: "Master Zone",
      stage: "Stage",
      air: "Air",
      radiant: "Radiant",
      combinated: "Combined",

      labelfor: "Label Name for",
      visibleInMenu: "Visible in Menu",
      Saving: "Saving...",
      Select: "Select",
      onlyPng: "Only PNG",
      invalidFormat: "Invalid format. Only PNG files are allowed.",
      fileTooLarge: "File too large. Maximum size is 1MB.",
      missingProjectId: "Missing projectId. Please try again.",
      clientLimitMax: "Client limit cannot be greater than resources limit.",
      deleteMessageTitle: "Delete Message",
      deleteMessageBody: "Do you want to delete this message? This action cannot be undone.",
      unreadMessage: "unread message",
      unreadMessages: "unread messages",
      deletedMessage: "deleted message",
      customNewUserMail: "Custom email for new user",
      initialText: "Initial text",
      emailClientReservation: "Client reservation",
      emailStatusSection: "Status",
      emailStatusNew: "New",
      emailStatusUpdate: "Updated",
      emailStatusDeleted: "Deleted",
      emailClientReservationStatusNew: "New client reservation",
      emailClientReservationStatusUpdate: "Updated client reservation",
      emailClientReservationStatusDeleted: "Canceled client reservation",
      emailBookingAmenity: "Booking Spaces",
      emailBookingService: "Booking Service",
      emailBookingStatusNew: "New booking",
      emailBookingStatusUpdate: "Updated booking",
      emailBookingStatusDeleted: "Deleted booking",
      emailSupportCase: "Support case",
      emailDailyUnreadChat: "Daily unread chat",
      emailSupportCaseStatusNew: "New support case",
      emailSupportCaseStatusUpdate: "Updated support case",
      emailSupportCaseStatusDeleted: "Deleted support case",
      emailFieldSubjectSuffix: "Mail subject",
      emailFieldEmailTitle: "Email title",
      emailFieldEmailText: "Email text",
      emailFieldEmailTextClient: "Client message text",
      emailFieldStateSolvedLabel: "Solved state text",
      emailFieldPendingMessageText: "Pending state message text",
      emailFieldStatusText: "Status text",
      emailAccessMethodsSection: "Access methods",
      emailAccessMethodWeb: "Web access",
      emailAccessMethodApp: "App access",
      compareCharts: "Compare",
      comparisonSelected: "Selected",
      addToComparison: "Add to comparison",
      applyColor: "Apply color",
    },
  },
  es: {
    translation: {
      clientReservationsActives: "Reservas de Clientes Activas",
      clientReservationsInactives: "Reservas de Clientes Inactivas",
      clientReservationsTimeline: "Calendario de Reservas de Clientes",
      amenityEventsWithActiveClientReservation: "Eventos de Espacios con Reserva de Cliente Activa",
      amenityEventsAllExisting: "Todos los Eventos de Espacios Existentes",
      serviceEventsWithActiveClientReservation:
        "Eventos de Servicios con Reserva de Cliente Activa",
      serviceEventsAllExisting: "Todos los Eventos de Servicios Existentes",
      supportCasesWithActiveClientReservation: "Casos de Soporte con Reserva de Cliente Activa",
      supportCasesAllExisting: "Todos los Casos de Soporte Existentes",
      chatWithActiveClientReservation: "Chats con Reserva de Cliente Activa",
      chatAllExisting: "Todos los Chats Existentes",
      todayLabel: "Hoy",
      oneWeek: "1 semana",
      thisWeek: "Semana Actual",
      oneMonth: "1 mes",
      noEvents: "Sin eventos",
      more: "m\u00e1s",
      noMoreElements: "no hay m\u00e1s elementos",
      selectProject: "Seleccione proyecto",
      select_project_and_apartment: "Seleccione proyecto y apartamento",
      selectYourReservation: "Seleccione su reserva",
      managerMode: "Modo Gestor",
      accessAsAdministrator: "Acceder como administrador",
      apartment_already_reserved_in_range: "Apartamento ya reservado en el rango",
      active: "Activa",
      availability: "Disponibilidad",
      available: "Disponible",
      activeReservation: "Reserva activa",
      total: "Total",
      totalCost: "Coste total",
      invalid_dates: "Fechas inválidas",
      userValidationPending: "Validación de usuario pendiente",
      userValidationPendingSubtitle: "Estamos validando su usuario, por favor, tenga paciencia",
      account: "Cuenta",
      sections: "Secciones",
      menuSections: "Secciones de Menú de Proyecto",
      projectManagerSharedSectionsDescription:
        "Estas opciones dan acceso a secciones compartidas entre el Menú Principal, el Dashboard y el Menú de Proyecto.",
      projectManagerExclusiveMenuSectionsDescription: "Secciones exclusivas del Menú de Proyecto.",
      projectManagerMenuAccess: "Acceso a Menú de Proyecto",
      settings: "Ajustes",
      cloudApis: "Cloud APIs",
      chat: "Chat",
      typeMessage: "Escribe un mensaje...",
      Logout: "Cerrar Sesión",
      userGrantTimeout: "El acceso para el usuario ha caducado",
      userHasNoGrant: "El usuario no tiene acceso",
      Company: "Compañía",
      "Basic Info": "Información Básica",
      "Custom App": "Personalización",
      "Custom Welcome Mobile": "Bienvenida App Móvil",
      "Custom Colors in App": "Colores Personalizados en App Móvil",
      "Custom Font in App": "Fuente Personalizada en App Móvil",
      customFont: "Fuente Personalizada",
      customCardColor: "Color de tarjetas personalizado",
      customEmailToClients: "Correo personalizado para clientes",
      customApp: "Personalización App Móvil",
      "Custom Project Menu": "Menú Proyecto",
      "First Name": "Nombre",
      "Last Name": "Apellido",
      "Phone Number": "Número de Teléfono",
      "Project Managers": "Gestores de Proyecto",
      Language: "Idioma",
      Address: "Dirección",
      City: "Ciudad",
      Postcode: "Código Postal",
      "VAT Number": "CIF",
      // Password
      Success: "Éxito!",
      Password: "Contraseña",
      PasswordRepeat: "Contraseña Repetida",
      "Wrong Password": "Contraseña Errónea",
      "Unknown Error": "Error Desconocido",
      "Different Passwords": "Contraseñas Diferentes",
      "One special character": "Un Carácter Especial",
      "One capital letter": "Una Letra Mayúscula",
      "Min 8 characters": "Mínimo 8 Caracteres",
      "One number": "Un Número",
      "Change Password": "Cambiar Contraseña",
      "Current Password": "Contraseña Actual",
      "New Password": "Contraseña Nueva",
      "Confirm New Password": "Confirmar Contraseña Nueva",
      "Update Password": "Actualizar Contraseña",
      "Please follow this guide for a strong password":
        "Por favor, siga esta guía para una contraseña segura",
      "Password requirements": "Requerimientos de Contraseña",
      Notifications: "Notificaciones",
      notificationsToClients: "Notificaciones a clientes",
      Type: "Tipo",
      Communication: "Comunicación",
      "Notify communication errors with Onna BTR devices":
        "Notificar errores de comunicación con equipos Onna BTR",
      Alerts: "Alertas",
      "Notify technical alerts comming from sensors":
        "Notificar alertas técnicas enviadas por sensores",
      projectNotificationsDevicesDescription:
        "Notificar alertas sobre comunicacion y cambios de estado de los dispositivos del proyecto",
      projectNotificationsMetricsLimitDescription:
        "Notificar cuando se superen los limites de metricas configurados en este proyecto",
      "Ask Onna Team for account deletion": "Solicitar al equipos de Onna que elimine su cuenta",
      "Delete Account": "Eliminar Cuenta",
      Profile: "Perfil",
      uploadFile: "Subir Archivo",
      customWelcomeBackgroundColor: "Color de fondo personalizado de bienvenida",
      customIconColor: "Color de iconos personalizado",
      customAppBackgroundColor: "Color de fondo personalizado de la app",
      welcomeBackgroundColor: "Color de fondo de bienvenida",
      configurationSent: "Configuración enviada",
      image: "Imagen",
      wrongSize: "Tamaño incorrecto, debe ser 256x256",
      Save: "Guardar",
      Delete: "Eliminar",
      Required: "Requerido",
      clients: "Clientes",
      clientReservationsAll: "Todas las Reservas de Clientes",
      clientReservations: "Reservas de Clientes",
      clientReservation: "Reserva de Cliente",
      client: "Cliente",
      createClient: "Crear Cliente",
      clientCreatedSuccessfully: "Cliente creado correctamente",
      clientUpdatedSuccessfully: "Cliente actualizado correctamente",
      errorCreatingClient: "Error al crear cliente",
      errorUpdatingClient: "Error al actualizar cliente",
      clientRemovedSuccessfully: "Cliente eliminado correctamente",
      errorRemovingClient: "Error al eliminar cliente",
      clientReservationCreatedSuccessfully: "Reserva de cliente creada correctamente",
      errorCreatingClientReservation: "Error al crear reserva de cliente",
      clientReservationUpdatedSuccessfully: "Reserva de cliente actualizada correctamente",
      errorUpdatingClientReservation: "Error al actualizar reserva de cliente",
      clientReservationRemovedSuccessfully: "Reserva de cliente eliminada correctamente",
      errorRemovingClientReservation: "Error al eliminar reserva de cliente",
      emailAlreadyExists: "El correo ya existe",
      newEmail: "Nuevo Correo",
      newEmailConfirmation: "Confirmar Nuevo Correo",
      errorCreateCode: "Error al crear código de puerta",
      users: "Usuarios",
      user: "Usuario",
      "These are the users": "Estos son los usuarios compartidos por todos tus proyectos",
      stepNotUndo: "Este paso no se puede deshacer",
      stepNotUndoClient:
        "Esta acción no se puede deshacer. El cliente se eliminará junto con todos sus datos, reservas y eventos.",
      stepNotUndoClientReservation:
        "Esta acción no se puede deshacer. La reserva del cliente se eliminará junto con todos sus datos y eventos.",
      projectManagerAddMainUserError:
        "Este usuario no puede añadirse como gestor de proyecto porque la cuenta ya es un usuario principal",
      confirmation: "¿Estás seguro?",
      showing: "Mostrando",
      of: "de",
      entries: "entradas",
      project: "Proyecto",
      removeNotEmpty: "El proyecto no está vacío, no se puede eliminar",
      createdAt: "Fecha Creación",
      lastCreatedAt: "Fecha Última Notificación",
      unreadNumber: "Notificaciones No Leídas",
      unreadByClientNumber: "No Leídas por Cliente",
      totalNumber: "Total Notificaciones",
      readByClient: "leida por el cliente",
      enabled: "Activo",
      to: "a",
      add: "Añadir",
      edit: "Editar",
      projects: "Proyectos",
      allProjects: "Todos los Proyectos",
      "These are the projects": "Estos son tus proyectos",
      name: "Nombre",
      certifications: "Certificaciones",
      onnaDevices: "Dispositivos Onna",
      onnaDevicesDetails: "Detalle de Dispositivos Onna",
      onnaDevice: "Dispositivo Onna",
      amenity: "Espacio",
      amenities: "Espacios",
      amenityEvents: "Eventos de Espacios",
      reservationsToday: "Espacios Hoy",
      reservationsNext: "Proximas Espacios",
      amenityDuration: "Tiempo de Reserva",
      event: "Evento",
      events: "Eventos",
      resourcesLimited: "Recursos Limitados",
      resourcesLimitNumber: "Límite de Recursos",
      cost: "Coste",
      costPositive: "El coste debe ser un número positivo",
      requiredPositiveInteger: "Se requiere un número entero positivo",
      mustBeANumber: "Debe ser un número",
      mustBeMinOne: "Mínimo 1",
      startMustBeEarlier: "La hora de inicio debe ser anterior",
      endMustBeLater: "La hora de fin debe ser posterior",
      availableDays: "Días disponibles",
      minPreviousTime: "Tiempo mínimo de antelación",
      minCancelTime: "Tiempo mínimo para cancelar",
      autoConfirmateEnable: "Confirmación automática",
      onlyStartInEvents: "Solo inicio desde eventos",
      associatedServicesEnable: "Habilitar servicios",
      associatedServices: "Servicios asociados",
      isAssociated: "Asociado",
      associatedReservationEnable: "Asociado a Espacio",
      onlyAssociated: "Solo Asociado",
      servicesCategories: "Categorias de Servicios",
      selectApartmentFirst: "Seleccione un apartamento primero",
      selectClientReservationFirst: "Seleccione un cliente con reserva activa",
      projectManager: "Gestor de Proyecto",
      projectManagerUnauthorizedEventEdit:
        "No está autorizado para modificar este evento porque no pertenece a uno de sus proyectos autorizados",
      invalid_service_quantity: "Cantidad de servicio inválida",
      serviceLimitReached: "Se alcanzó el límite del servicio",
      eventService: "Evento de Servicio",
      eventAmenity: "Evento de Espacio",
      eventUpdated: "Evento actualizado",
      eventAdded: "Evento añadido",
      eventRemoved: "Evento eliminado",
      eventRemoveFailed: "Error al eliminar el evento",
      eventUpdateFailed: "Error al actualizar el evento",
      eventAddFailed: "Error al añadir el evento",
      serviceAddedOrUpdated: "Servicio añadido o actualizado",
      createdServiceEvents: "Eventos de servicio creados",
      noServiceEventsYet: "Aún no hay eventos de servicio",
      serviceNumber: "Número de servicios solicitado",
      amenityNumber: "Número de espacios solicitado",
      clientLimit: "Límite Cliente",
      iconName: "Nombre del Icono",
      update: "Actualizar",
      pending: "Pendiente",
      processing: "En proceso",
      confirmed: "Confirmado",
      canceled: "Cancelado",
      completed: "Completado",
      currency: "Moneda",
      no: "No",
      yes: "Sí",
      additionalInfo: "Información Adicional",
      unitCost: "Coste unitario",
      requestNumber: "Número de solicitud",
      inactive: "Inactiva",
      none: "Ninguno",
      multiple: "multiple",
      goToServiceEvent: "Ir al evento de servicio",
      serviceEventNotFound: "Evento de servicio no encontrado",
      service: "Servicio",
      serviceEvents: "Eventos de Servicios",
      services: "Servicios",
      resource: "Recurso",
      resources: "Recursos",
      serviceDuration: "Tiempo de Servicio",
      weekDayMonday: "Lunes",
      weekDayTuesday: "Martes",
      weekDayWednesday: "Miércoles",
      weekDayThursday: "Jueves",
      weekDayFriday: "Viernes",
      weekDaySaturday: "Sábado",
      weekDaySunday: "Domingo",
      unknown: "Desconocido",
      accessControls: "Controles de Accesos",
      serviceEventsToday: "Eventos de Servicios Hoy",
      serviceEventsUpcoming: "Próximos Eventos de Servicios",
      accessControl: "Control Accesos",
      titleAccesses: "Control Accesos",
      code: "Código",
      lockCommunicationError: "El equipo no comunica",
      roomsLocksList: "Habitaciones - Listado de puertas",
      commonLocksList: "Zonas Comunes - Listado de puertas",
      import: "Importar",
      system: "Sistema",
      configured: "Configurado",
      true: "Verdadero",
      false: "Falso",
      isOverlapping: "Conflicto con evento existente",
      startTime: "Hora Comienzo",
      endTime: "Hora Fin",
      previousDays: "Días Antelación",
      state: "Estado",
      apartment: "Apartamento",
      apartments: "Apartamentos",
      onnaId: "ID Onna",
      apartmentId: "ID Apartamento",
      configuration: "Configuración",
      customizeDashboard: "Configura tu Dashboard",
      navbar: "Barra Lateral",
      customizeNavbar: "Personaliza tu Barra Lateral",
      dark: "Oscura",
      transparent: "Transparente",
      white: "Blanca",
      navbarMini: "Barra Lateral Mini",
      darkMode: "Modo Oscuro",
      notifications: "Notificaciones",
      notificationsDetails: "Detalle de Notificaciones Por Apartamento",
      message: "Mensaje",
      read: "Leídas",
      notRead: "No Leídas",
      last24h: "Últimas 24h",
      apartmentsWithUnread: "Apartamentos con no leídas",
      apartmentsWithoutUnread: "Apartamentos sin pendientes",
      unreadNotifications: "Notificaciones no leídas",
      notificationsLast24h: "Notificaciones últimas 24h",
      correct: "Correctos",
      errored: "Con errores",
      offline: "Desconectado",
      online: "Conectado",
      lights: "Luces",
      titleLights: "Luces",
      shutters: "Motores",
      titleShutters: "Motores",
      alarms: "Alarmas",
      titleAlarms: "Alarmas",
      temperature: "Temperatura",
      titleThermostat: "Temperatura",
      thermostats: "Termostatos",
      supplies: "Suministros",
      titleSupplies: "Suministros",
      others: "Otros",
      titleOthers: "Otros",
      invoice: "Factura",
      generate: "Generar",
      startDate: "Fecha Comienzo",
      endDate: "Fecha Fin",
      oldClientMessage:
        "Este cliente ha sido creado con una versión antigua del software. A partir de ahora, debe usar la interfaz de reservas para cambiar su disponibilidad. Pulse guardar para actualizarlo.",
      randomEntryCode: "Crear y enviar código de puerta aleatorio",
      entryCode: "Código de puerta",
      hotWater: "Agua Caliente",
      coldWater: "Agua Fría",
      electricity: "Electricidad",
      gas: "Gas",
      limits: "Límites de Métrica",
      dailyLimit: "Límite Diario",
      monthlyLimit: "Límite Mensual",
      dashboard: "Dashboard",
      support: "Soporte",
      connected: "Conectados",
      disconnected: "Desconectados",
      withError: "Con error",
      supportOpen: "Abiertos",
      supportInProgress: "En proceso",
      supportCompleted: "Completado",
      supportCasesCreatedSuccessfully: "Caso de soporte creado correctamente",
      supportCasesUpdatedSuccessfully: "Caso de soporte actualizado correctamente",
      supportCasesRemovedSuccessfully: "Caso de soporte eliminado correctamente",
      errorCreatingSupportCases: "Error al crear caso de soporte",
      errorUpdatingSupportCases: "Error al actualizar caso de soporte",
      errorRemovingSupportCases: "Error al eliminar caso de soporte",
      lastUpdate: "Última Actualización",
      consumptions: "Consumos",
      device: "Dispositivo",
      devices: "Dispositivos",
      moment: "Momento",
      moments: "Momentos",
      power: "Potencia",
      energy: "Energía",
      month: "Mes",
      year: "Año",
      day: "Día",
      time: "Hora",
      hour: "Hora",
      hourlyPeriod: "Horario",
      dailyPeriod: "Diario",
      monthlyPeriod: "Mensual",
      annualPeriod: "Anual",
      detailPeriod: "Detalle",
      minutes: "Minutos",
      byDates: "Por Fechas",
      standart: "Estándar",
      allApartments: "Todos los Apartamentos",
      customSearch: "Consulta Personalizada",
      lastHour: "Valor Último Hora",
      metric: "Métrica",
      show: "Mostrar",
      showInApp: "Mostrar en App",
      unit: "Unidad",
      units: "Unidades",
      metricConfig: "Configuración de Métricas",
      customMetrics: "Métricas Custom",
      binaryValue: "Valor binario (1/0)",
      influxErrorRequest: "No se pudo procesar la respuesta.",
      Δincrease: "Δ Incremento",
      period: "Periodo",
      select: "Selecciona",
      presence: "Presencia",
      timeInPresence: "Tiempo en presencia (minutos)",
      electricEnergy: "Energía Eléctrica",
      electricPower: "Potencia Eléctrica",
      setpointTemp: "Temp. Deseada",
      thermalEnergyCooling: "Energía Térmica Frío",
      thermalEnergyHeating: "Energía Térmica Calor",
      custom1Linear: "Custom 1 Lineal",
      custom1Incremental: "Custom 1 Incremental",
      custom2Linear: "Custom 2 Lineal",
      custom2Incremental: "Custom 2 Incremental",
      customName: "Nombre Personalizado",
      makeQuery: "Consultar",
      min: "Mín",
      max: "Máx",
      average: "Promedio",
      dataType: "Tipo de Dato",
      analytics: "Análisis",
      JAN: "ENE",
      FEB: "FEB",
      MAR: "MAR",
      APR: "ABR",
      MAY: "MAY",
      JUN: "JUN",
      JUL: "JUL",
      AUG: "AGO",
      SEP: "SEP",
      OCT: "OCT",
      NOV: "NOV",
      DEC: "DIC",
      ΔT: "Δ Temp. Diferencial",
      reload: "Recargar",
      updated: "Actualizando",
      noPossibleShowData: "No existen datos.",
      noMetricsConfiguredToShow: "No hay métricas configuradas para mostrar.",
      lastData: "Última Actualización",
      lastValue: "Valor Actual",
      lastDay: "Valor Último Día",
      lastMonth: "Valor Último Mes",
      signIn: "Acceder",
      signUp: "Darse de alta",
      email: "Email",
      emailConfig: "Configuración de Email",
      enterEmailAndPassword: "Introduzca usuario y contraseña",
      password: "Contraseña",
      dontHaveAccount: "¿No tiene una cuenta todavía?",
      forgotPassword: "¿Contraseña olvidada?",
      resetPassword: "Reiniciar contraseña",
      emailSent: "Email Enviado!",
      emailResetSent: "Email para reiniciar contraseña enviado!",
      invalidPassword: "Contraseña inválida",
      invalidEmail: "Email inválido",
      userNotFound: "Usuario no encontrado",
      iAgreeThe: "Acepto los",
      joinUsToday: "Únase a nosotros",
      today: " Hoy",
      yesterday: "Ayer",
      termsAndConditions: "Términos y condiciones",
      weakPassword: "Contraseña débil",
      weakPassword1:
        "La contraseña debe contener al menos 8 caracteres, una mayúscula, una minúscula y un número",
      emailInUse: "Email en uso",
      wrongPasswordForExistingEmail:
        "No hemos podido verificar tus credenciales. Si la cuenta existe, usa recuperar contraseña",
      mustUseExistingPassword:
        'Por favor, use la contraseña existente para este correo electrónico o vuelva atras y pulse en "Restablecer Contraseña" si no la recuerda.',
      cannotRegisterMainUserAlreadyProjectManager:
        "Esta cuenta no puede registrarse como usuario principal porque ya pertenece a un gestor de proyecto.",
      alreadyHaveAccount: "¿Ya tiene una cuenta?",
      addOnnaDevice: "Añadir dispositivo Onna",
      notOpen:
        "La conexión con el dispositivo no está abierta. Ponga el dispositivo en modo enlace",
      alreadyAssigned: "No dispone de permisos para asignar el dispositivo a su cuenta",
      unknownDevice: "Onna ID desconocido",
      unknownError: "Error desconocido",
      "IP Address": "Dirección IP",
      "IP Address Type": "Tipo Dirección IP",
      "Hardware Version": "Versión de Hardware",
      "App Version": "Versión de Software",
      "Onna Model": "Modelo Onna",
      Update: "Actualizar",
      Timezone: "Zona Horaria",
      download: "Descargar",
      btnOn: "Encender",
      btnOff: "Apagar",
      labelOn: "Encendido",
      labelOff: "Apagado",
      btnUp: "Subir",
      btnDown: "Bajar",
      btnOpen: "Abrir",
      btnClose: "Cerrar",
      noProjectsAvailable: "No hay proyectos disponibles",
      noResourcesAvailable: "No hay recursos disponibles para este proyecto",
      schedule: "Programación",
      scheduled: "Programado",
      value: "Valor",
      date: "Fecha",
      timestamp: "Timestamp",
      days: "Días",
      schedules: "Programaciones",
      weekDays: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
      uncalibrated: "Descalibrado",
      locked: "Bloqueado",
      unlocking: "Desbloqueando",
      unlocked: "Desbloqueado",
      locking: "Bloqueando",
      unlatched: "Desbloqueado",
      unlatching: "Desbloqueando",
      motorBlocked: "Motor Bloqueado",
      undefined: "Desconocido",
      loading: "Cargando",
      unlock: "Desbloquear",
      lock: "Bloquear",
      occupancy: "Ocupación",
      occupied: "Ocupado",
      unoccupied: "Desocupado",
      codeAlreadyExists: "El código ya existe",
      setpoint: "Deseada",
      mode: "Modo",
      fan: "Ventilador",
      dry: "Secar",
      cool: "Enfriar",
      heat: "Calentar",
      auto: "Auto",

      veryLow: "Muy baja",
      low: "Baja",
      mediumLow: "Media-baja",
      medium: "Media",
      mediumHigh: "Media-alta",
      high: "Alta",
      veryHigh: "Muy alta",
      intensity: "Intensidad",
      whiteL: "Blanco",

      angleConf: "Orientación Aire",
      master: "Maestro",
      zone: "Zona",
      zoneMaster: "Zona Maestra",
      stage: "Etapa",
      air: "Aire",
      radiant: "Radiante",
      combinated: "Combinado",

      labelfor: "Nombre de Etiqueta de",
      visibleInMenu: "Visible en Menú",
      Saving: "Guardando...",
      Select: "Seleccionar",
      onlyPng: "Solo PNG",
      invalidFormat: "Formato inválido. Solo se permiten archivos PNG.",
      fileTooLarge: "Archivo demasiado grande. El tamaño máximo es 1MB.",
      missingProjectId: "Falta el projectId. Inténtalo de nuevo.",
      clientLimitMax: "El límite de clientes no puede ser mayor que el límite de recursos.",
      deleteMessageTitle: "Eliminar mensaje",
      deleteMessageBody: "¿Quieres eliminar este mensaje? Esta acción no se puede deshacer.",
      unreadMessage: "mensaje no leído",
      unreadMessages: "mensajes no leídos",
      deletedMessage: "mensaje eliminado",
      customNewUserMail: "Correo electrónico personalizado para nuevo usuario",
      initialText: "Texto inicial",
      emailClientReservation: "Reserva de cliente",
      emailStatusSection: "Estado",
      emailStatusNew: "Nueva",
      emailStatusUpdate: "Actualizada",
      emailStatusDeleted: "Cancelada",
      emailClientReservationStatusNew: "Nueva reserva de cliente",
      emailClientReservationStatusUpdate: "Reserva de cliente actualizada",
      emailClientReservationStatusDeleted: "Reserva de cliente cancelada",
      emailBookingAmenity: "Reserva de Espacio",
      emailBookingService: "Reserva de Servicio",
      emailBookingStatusNew: "Nueva reserva",
      emailBookingStatusUpdate: "Reserva actualizada",
      emailBookingStatusDeleted: "Reserva eliminada",
      emailSupportCase: "Caso de soporte",
      emailDailyUnreadChat: "Chat diario sin leer",
      emailSupportCaseStatusNew: "Nuevo caso de soporte",
      emailSupportCaseStatusUpdate: "Caso de soporte actualizado",
      emailSupportCaseStatusDeleted: "Caso de soporte eliminado",
      emailFieldSubjectSuffix: "Asunto del mail",
      emailFieldEmailTitle: "Título del email",
      emailFieldEmailText: "Texto del email",
      emailFieldEmailTextClient: "Texto para el cliente",
      emailFieldStateSolvedLabel: "Texto estado resuelto",
      emailFieldPendingMessageText: "Texto del estado pendiente",
      emailFieldStatusText: "Texto del estado",
      emailAccessMethodsSection: "Métodos de acceso",
      emailAccessMethodWeb: "Acceso web",
      emailAccessMethodApp: "Acceso app",
      compareCharts: "Comparar",
      comparisonSelected: "Seleccionadas",
      addToComparison: "Añadir a comparativa",
      applyColor: "Aplicar color",
    },
  },
};

export default translations;
